import { useEffect, useState } from "react";

export default function useVirtualViewport() {
  const [viewport, setViewport] = useState<{
    width: number | undefined;
    height: number | undefined;
  }>();
  useEffect(() => {
    if (!visualViewport) return;

    function handleResize() {
      // Set window width/height to state
      setViewport({
        width: visualViewport?.width,
        height: visualViewport?.height,
      });
    }

    handleResize();

    visualViewport.addEventListener("resize", () => {
      handleResize();
    });
    // return () => visualViewport?.removeEventListener('resize', handleResize)
  }, []);

  return viewport;
}
